import React from 'react'
import tw from 'tailwind-styled-components'

const TwTitle = tw.div`
  flex
  items-center
  h-56
  py-12
  text-sm-semibold
  text-panel-text-primary
`

export const SimplePageTitle = ({title}: {title: string}) => (
  <TwTitle>{title}</TwTitle>
)
